<template>
  <div class="publicMain">

    <!-- 模糊查询 -->
    <div class="childrenFileSelect">
      <el-form :inline="true" :model="formModel" class="demo-form-inline">

        <el-form-item label="名称">
          <el-input v-model="formModel.theme"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="formModel.theme"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onCheck">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 新增按钮 -->
    <div class="add">
      <el-button type="primary" @click="add" size="medium">新增</el-button>
    </div>

    <!-- 表格 -->
    <div class="table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column type="index" label="序号" width="50" header-align="center" align="center"></el-table-column>
        <el-table-column
          v-for="(item,index) in tableColumn"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <div v-if="item.type=='button'" >
              <el-tooltip class="item" effect="light" content="查看" placement="top-start">
                <button class="iconfont icon-chakan tabBtn" @click="check(scope.row)"></button>
              </el-tooltip>
              <el-tooltip class="item" effect="light" content="修改" placement="top-start">
                <button class="iconfont icon-bianji3 tabBtn" @click="compile(scope.row)"></button>
              </el-tooltip>
              <el-tooltip class="item" effect="light" content="删除" placement="top-start">
                <button class="iconfont icon-icon7 tabBtn" @click="remove(scope.row)"></button>
              </el-tooltip>
               <el-button size="mini" type="primary" @click="pass" v-if="scope.row.state==0">启用</el-button>
                <el-button size="mini" type="danger" @click="unpass" v-if="scope.row.state==0">禁用</el-button>
            </div>
            <div v-if="item.type=='state'">
              <el-tag v-if="scope.row[item.prop]==0" type="error">禁用</el-tag>
              <el-tag v-if="scope.row[item.prop]==1" type="success">启用</el-tag>
            </div>
            <div v-if="item.type=='sex'">
              <el-tag v-if="scope.row[item.prop]==0" type="error">男</el-tag>
              <el-tag v-if="scope.row[item.prop]==1" type="success">女</el-tag>
            </div>
            <div
              v-else
              :style="{'text-align':item.align?item.align:'center'}"
            >{{scope.row[item.prop]}}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 弹窗 -->
    <el-dialog :title="title" :visible.sync="visible" width="50%">
      <div class="slot">
        <serveCompanyDetailSecondDialog
          :buttonType="buttonType"
          :row="row"
          @save="save"
          @cancel="cancel"
          v-if="visible"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  oldManOrganizationPeopleList,
  oldManOrganizationPeopleDelete,
  helpManageFamilyEnvEdit
} from "../api";
import serveCompanyDetailSecondDialog from "../components/serveCompanyDetailSecondDialog.vue";
export default {
  components: {
    serveCompanyDetailSecondDialog
  },
  data() {
    return {
      currentPage: 1, //默认展示第一页
      buttonType: "", //按钮的类型
      row: {}, //点击当前按钮的row数据
      title: "",
      visible: false,
      formModel: {}, //模糊查询
      //table表格的column
      tableColumn: [
        {
          prop: "name",
          label: "姓名"
        },
        {
          prop: "phone",
          label: "员工号"
        },
        {
          prop: "phone",
          label: "手机号码"
        },
        {
          type:'sex',
          prop: "sex",
          label: "性别"
        },
        {
          prop: "age",
          label: "年龄"
        },
        {
          type:'state',
          prop: "state",
          label: "状态"
        },
        {
          type: "button",
          label: "操作"
        }
      ],
      //table表格的数据
      tableData: [],
      total: 0, //总数据
      pageNo: 1,
      pageSize: 10
    };
  },
  methods: {
    //模糊搜索的查询
    onCheck() {
      this.getHelpManageAPI({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        ...this.formModel
      });
    },
    //模糊搜索的重置
    onReset() {
      this.formModel = {};
      this.getHelpManageAPI({
        pageNo: 1,
        pageSize: 10
      });
    },
    //每页请求N条数据
    handleSizeChange(val) {
      this.pageSize = val;
      this.getHelpManageAPI();
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: "success"
      });
    },
    //请求N页数据
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getHelpManageAPI();
      this.$message({
        message: `请求第${val}页数据成功`,
        type: "success"
      });
    },
    //增加
    add() {
      this.buttonType = "add";
      this.visible = true;
      this.title = "新增";
    },
    //查看
    check(e) {
      this.buttonType = "check";
      this.row = e;
      this.visible = true;
      this.title = "查看";
    },
    //编辑
    compile(e) {
      this.buttonType = "compile";
      this.row = e;
      this.visible = true;
      this.title = "编辑";
    },
    //删除
    remove(e) {
      this.$confirm("确认永久删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error"
      })
        .then(() => {
          oldManOrganizationPeopleDelete({ id: e.id }).then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getHelpManageAPI();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //审核
    audit(e) {
      this.buttonType = "audit";
      this.row = e;
      this.visible = true;
      this.title = "审核";
    },
    //拿到列表
    getHelpManageAPI(e) {
      let params = Object.assign({}, e, {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      });
      oldManOrganizationPeopleList(params).then(res => {
        this.tableData = res.content.list;
        this.total = res.content.count;
      });
    },
    //保存按钮
    save(e, type = "保存") {
      helpManageFamilyEnvEdit(e).then(res => {
        this.$message({
          message: type + "成功",
          type: "success"
        });
        this.visible = false;
        this.getHelpManageAPI();
      });
    },
    //取消按钮
    cancel() {
      this.visible = false;
      this.getHelpManageAPI();
    },
    //通过
    pass(row) {
      this.$confirm("确认启用吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          childrenActiveHomePass({ id: row.id, state: 1 }).then(res => {
            this.$message({
              type: "success",
              message: "操作成功!"
            });
            this.getHelpManageAPI();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    //不通过
    unpass(row) {
      this.$confirm("确认禁用吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          childrenActiveHomePass({ id: row.id, state: 0 }).then(res => {
            this.$message({
              type: "success",
              message: "操作成功!"
            });
            this.getHelpManageAPI();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    }
  },
  created() {
    this.getHelpManageAPI({
      pageNo: 1,
      pageSize: 10
    });
  }
};
</script>

<style lang="less" scoped>
.publicMain {
  background-color: #fff;
  padding: 16px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;

}
// 面包屑导航box
.mianbao {
  box-sizing: border-box;
  margin: -16px -16px 0;
  background-color: #eef1f6;
  height: 47px;
  align-items: center;
  padding-left: 16px;
  margin-bottom: 16px;
}
.childrenFileSelect {
  border: 1px solid rgb(230, 230, 230);
   padding: 20px;
  margin-top: 20px;
}
.table {
  margin: 20px 0px;
}
.add {
  margin: 20px 0px;
}
.slot {
  width: 90%;
  margin: auto;
}
.icon-icon7 {
color: #dd3020;

}
.icon-tongguos {
  color: #0d5795
}
</style>
